import type { ITenantInfo } from '@lucimark/shared/models/player-registration-payload'

/**
 * Whether the campaign-update toast (bottom-left) should be shown.
 * Hidden when tenant muted operator notifications in Settings, or when the status
 * overlay already shows content-change feedback (Feed-row spinner; avoids double cues).
 */
export function campaignUpdateNotificationVisible(
  tenant: ITenantInfo | null,
  campaignUpdateReceivedAt: number,
  nowMs: number,
  visibleDurationMs: number,
  options?: { suppressForStatusOverlayFeedback?: boolean }
): boolean {
  if (tenant === null) {
    return false
  }
  if (tenant.playerOperatorNotificationsMuted === true) {
    return false
  }
  if (options?.suppressForStatusOverlayFeedback === true) {
    return false
  }
  if (campaignUpdateReceivedAt <= 0) {
    return false
  }
  return nowMs - campaignUpdateReceivedAt < visibleDurationMs
}
